import Command from '../../actions/command';
import {call, fork, put, take} from 'redux-saga/effects';
import {Action} from 'redux-actions';
import Event from '../../actions/event';
import Api from '../../../api';
import {FetchEmployeeRateListPayload} from '../../actions/dashboardCommand';

const onFetchEmployeeRateList = function*(_data: FetchEmployeeRateListPayload) {
    try {
        const rates: any[] = yield call(Api.Query.employeeRateList);
        yield put(Event.Dashboard.employeeRateListFetched({ rates }));
    } catch (e) {
        yield put(Command.Notification.enqueueNotification({
            severity: 'error',
            message: 'Stundensätze konnten nicht geladen werden.',
        }));
    }
};

export function* fetchEmployeeRateListFlow() {
    while (true) {
        const action: Action<FetchEmployeeRateListPayload> =
            yield take(Command.Dashboard.fetchEmployeeRateList.toString());
        yield fork(onFetchEmployeeRateList, action.payload);
    }
}
